<template>
    <lv-base-column
        ref="column" v-bind="columnBinding">
        <template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
            <link-table-column-image-item
                :row="row"
                :edit-row="editRow"
                :row-index="rowIndex"
                :col="col"
                :col-index="colIndex"
                :fixed-row="fixedRow"
                v-bind="columnItemBinding"
                @click.native="lv_clickItem({row,rowIndex,editRow})"

                :auto-set-head-id="autoSetHeadId"
                :module-type="moduleType"
                :id-key="idKey"
                :big-url-key="bigUrlKey"
                :small-url-key="smallUrlKey"
                :shape="shape"
                :width="width"
                :height="height"
                :no-preview="noPreview"
                :custom-upload="customUpload"
				@upload-success="val=>$emit('upload-success', val)"
            />
        </template>
    </lv-base-column>
</template>

<script>
    import {ColumnMixin} from "../mixins";
    import LinkTableColumnImageItem from "./link-table-column-image-item";
    import LvBaseColumn from "../../table/lv-base-column";

    export default {
        name: 'link-table-column-image',
        components: {LvBaseColumn, LinkTableColumnImageItem},
        mixins: [ColumnMixin],
        props: {
            sort: {default: false},
            search: {default: false},
            align: {default: 'center'},
            fastRender: {default: false},
            disabledBatchModify: {default: true},           //默认不可以批量修改
            columnFilter: {default: false},                 //默认禁用列筛选

            autoSetHeadId: {type: Boolean, default: true},  //是否自动设置headId
            moduleType: {},                                 //图片的模块
            idKey: {type: String, required: true},          //图片id存放的id
            bigUrlKey: {type: String,},                     //图片大图key
            smallUrlKey: {type: String, required: true},    //图片小图key
            width: {type: Number, default: 60},            // 每张图片显示宽度
            height: {type: Number, default: 60},           // 每张图片显示高度
            shape: {type: String, default: 'round', validator: val => LinkUtils.oneOf(val, ['fillet', 'none', 'round'])},                              // 设定弹出框的圆角（fillet）方角（none）圆形（round）
            noPreview: {type: Boolean},                     //是否禁用点击图片放大显示
            customUpload: {type: Function},                 //自定义获取图片的函数
            /*getChangeField: {
                default() {
                    return () => {
                        const ret = []
                        !!this.idKey && ret.push(this.idKey)
                        !!this.bigUrlKey && ret.push(this.bigUrlKey)
                        !!this.smallUrlKey && ret.push(this.smallUrlKey)
                        return ret
                    }
                }
            },*/
        },
    };
</script>
